import { _breakP } from '../../js/lib/utils.js';

export default class autoPlaySlider {
  constructor() {
    this.autoPlaySliderFunc();
  }

  autoPlaySliderFunc() {
    const $autoPlaySlider = document.querySelectorAll('.js-autoPlaySlider');
    if (!$autoPlaySlider.length) return;

    $autoPlaySlider.forEach((elm, i) => {
      const elSlideLength = elm.querySelectorAll('.autoPlaySlider__slide').length;
      const minSliderLength = _breakP.SP
        ? Number(elm.dataset.spMinSlides)
        : Number(elm.dataset.pcMinSlides);
      const onlyDevice = elm.dataset.onlyDevice || '';

      if (
        onlyDevice &&
        ((onlyDevice === 'sp' && !_breakP.SP) ||
          (onlyDevice === 'pc' && _breakP.SP))
      ) {
        return;
      }

      if (elSlideLength < minSliderLength) {
        elm.classList.add('autoPlaySlider--disableMode');
        return;
      }

      elm.classList.add('autoPlaySlider--' + i);

      const container = elm.querySelector('.autoPlaySlider__group');
      if (container) container.setAttribute('id', `auto-slider-${i}`);

      const wrapper = elm.querySelector('.autoPlaySlider__wrapper');
      const originalSlides = Array.from(
        wrapper.querySelectorAll(':scope > .autoPlaySlider__slide')
      );

      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('role');
        clone.removeAttribute('aria-roledescription');
        clone.removeAttribute('aria-label');
        wrapper.appendChild(clone);
      });

      const speedMs = Number(elm.dataset.speed) || 10000;
      const duration = (speedMs * originalSlides.length) / 1000;
      elm.style.setProperty('--auto-play-slider-duration', `${duration}s`);
      elm.style.setProperty(
        '--auto-play-slider-gap-pc',
        `${elm.dataset.pcSpaceBetween || 0}px`
      );
      elm.style.setProperty(
        '--auto-play-slider-gap-sp',
        `${elm.dataset.spSpaceBetween || 0}px`
      );

      if (elm.dataset.autoplayReverse === 'on') {
        elm.classList.add('autoPlaySlider--reverse');
      }
      if (elm.dataset.dir === 'on') {
        elm.classList.add('autoPlaySlider--vertical');
      }

      const updateModalState = () => {
        if (document.body.classList.contains('is-modal-open')) {
          elm.classList.add('is-paused-modal');
        } else {
          elm.classList.remove('is-paused-modal');
        }
      };

      const mo = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName !== 'class') return;
          const had = mutation.oldValue?.includes('is-modal-open') ?? false;
          const has = document.body.classList.contains('is-modal-open');
          if (had === has) return;
          updateModalState();
        });
      });
      mo.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
      updateModalState();

      const controller = elm.querySelector('.js-autoPlaySlider-btn');
      if (controller) {
        const controllerText = controller.nextElementSibling;
        const labelName =
          container?.getAttribute('aria-label') || 'スライダー';
        controller.setAttribute('aria-controls', `auto-slider-${i}`);
        controller.setAttribute('aria-label', `${labelName}を止める`);

        controller.addEventListener('click', () => {
          const paused = elm.classList.toggle('is-paused-user');
          controller.setAttribute(
            'aria-expanded',
            paused ? 'false' : 'true'
          );
          controller.setAttribute(
            'aria-label',
            paused ? `${labelName}を再生する` : `${labelName}を止める`
          );
          controller.classList.toggle('is-stop', paused);
          if (controllerText)
            controllerText.textContent = paused ? 'START' : 'PAUSE';
        });
      }
    });
  }
}
